import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  CardPaymentRedirectRequest,
  CardPaymentRedirectResponse,
  CostSummary,
  CreateOrderResponse,
  ItemOffer,
  Offers,
  ReplacementOffer,
  UpfrontPaymentSummary,
} from '@dgx-pr-spa/shared/util';
import { BuildConfigService } from '@dgx-pr-spa/ui-components';

@Component({
  selector: 'app-order-summary',
  templateUrl: './order-summary.component.html',
  styleUrls: ['./order-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderSummaryComponent {
  constructor(public configService: BuildConfigService) {}

  @Input() order: CreateOrderResponse;
  @Input() offers: Offers;
  @Input() upfront: UpfrontPaymentSummary;
  @Input() cardPaymentRedirect: {
    request: CardPaymentRedirectRequest;
    response: CardPaymentRedirectResponse;
  };
  @Input() formData;
  @Input() selected: ReplacementOffer;
  @Input() itemOffer: ItemOffer;
  @Input() costSummary: CostSummary;
  @Input() optimizely: boolean;

  get dateOfDelivery(): string {
    if (this.formData?.delivery?.expectedDate instanceof Date) {
      const date = this.formData?.delivery?.expectedDate;
      const month =
        (date as Date).getMonth() + 1 < 10
          ? `0${(date as Date).getMonth() + 1}`
          : (date as Date).getMonth() + 1;
      const year = (date as Date).getFullYear();
      const calendarDate =
        (date as Date).getDate() < 10
          ? `0${(date as Date).getDate()}`
          : (date as Date).getDate();
      return `${calendarDate}/${month}/${year}`;
    }

    return this.formData?.delivery?.expectedDate;
  }
}
